export default __webpack_public_path__ + "static/media/productLines4.91367706.jpg";